<template>
  <div :class="$style.container">
    <payment-template>
      <project-header
        :project="getProject"
        :language="getLanguage"
        slot="header"
      />

      <access-denied
        slot="content"
        :email="getDisplayMerchantEmail"
        :title="$t('project.blocked.title')"
        :message="$t('project.blocked.message', { email: getDisplayMerchantEmail })"
      >
        <simple-button
          slot="action"
          variant="secondary"
          @click="handleRedirect"
        >
          {{ $t('common.return') }}
        </simple-button>
      </access-denied>

      <base-footer
        slot="footer"
        security
      />
    </payment-template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import BaseFooter from 'molecules/base/BaseFooter';
import SimpleButton from 'molecules/common/SimpleButton';
import AccessDenied from 'molecules/common/AccessDenied';
import ProjectHeader from 'organisms/project/ProjectHeader';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'ProjectBlocked',
  components: {
    BaseFooter,
    SimpleButton,
    AccessDenied,
    ProjectHeader,
    PaymentTemplate,
  },
  computed: {
    getProject() {
      if (this.$validate.isEmptyObject(this.PROJECT)) {
        return this.TRANSACTION;
      }

      return this.PROJECT;
    },
    ...mapState(['PROJECT', 'TRANSACTION']),
    ...mapGetters([
      'getLanguage',
      'getDisplayMerchantEmail',
      'getFailUrl',
    ]),
  },
  methods: {
    handleRedirect() {
      window.location.assign(this.getFailUrl);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +error-overlay
</style>
